/** API case-request category: Public Petitions (Case Type 9) */
export const PUBLIC_PETITION_CATEGORY_CODE = 'PUBLIC_PETITION';
export const FILE_CATEGORY_PUBLIC_PETITION = 'Public Petitions';

/** Set when file categories load from API; used for id-based routing once known. */
export let PUBLIC_PETITION_CATEGORY_ID = '';

export function setPublicPetitionCategoryId(id: string) {
  PUBLIC_PETITION_CATEGORY_ID = id.trim();
}

export function isPublicPetitionCategory(item: {
  id?: string;
  name?: string;
  code?: string;
}): boolean {
  const code = (item.code ?? '').trim().toUpperCase();
  const name = (item.name ?? '').trim().toLowerCase();
  if (code === PUBLIC_PETITION_CATEGORY_CODE || code.includes('PUBLIC_PETITION')) return true;
  if (PUBLIC_PETITION_CATEGORY_ID && item.id === PUBLIC_PETITION_CATEGORY_ID) return true;
  if (name.includes('public petition')) return true;
  return false;
}

export const PUBLIC_PETITION_WIZARD_STEPS = [
  { n: 1, lbl: 'Case Overview' },
  { n: 2, lbl: 'Parties Involved' },
  { n: 3, lbl: 'Timeline' },
  { n: 4, lbl: 'Submission & Physical File Delivery' },
  { n: 5, lbl: 'Upload Documents' },
] as const;

export type PublicPetitionWizardStep = (typeof PUBLIC_PETITION_WIZARD_STEPS)[number]['n'];
